export default __webpack_public_path__ + "static/media/portfolio-screeshot.53e614a9.png";